<template>
  <div class="q-gutter-y-sm">
    <q-item class="item" clickable="" exact="" exact-active-class="item-active" to="/users">
      <q-item-section avatar="">
        <q-icon size="md">
          <UserIcon />
        </q-icon>
      </q-item-section>
      <q-item-section>Shipper Management</q-item-section>
      <q-tooltip anchor="center right" self="center left">Shipper Management</q-tooltip>
    </q-item>
    <q-item class="item" clickable="" active-class="item-active" to="/users/transporter">
      <q-item-section avatar="">
        <q-icon size="md">
          <TruckIcon />
        </q-icon>
      </q-item-section>
      <q-item-section>Transporter Management</q-item-section>
      <q-tooltip anchor="center right" self="center left">Transporter Management</q-tooltip>
    </q-item>
    <q-item class="item" clickable="" active-class="item-active" to="/users/conversation">
      <q-item-section avatar="">
        <q-icon size="md">
          <MessagesIcon />
        </q-icon>
      </q-item-section>
      <q-item-section>Conversation Management</q-item-section>
      <q-tooltip anchor="center right" self="center left">Conversation Management</q-tooltip>
    </q-item>
    <q-item class="item" clickable="clickable" active-class="item-active" to="/users/reported">
      <q-item-section avatar="avatar">
        <q-icon size="md" name="report" />
      </q-item-section>
      <q-item-section>Reported Users</q-item-section>
      <q-tooltip anchor="center right" self="center left">Reported Users</q-tooltip>
    </q-item>
  </div>
</template>

<script>
import UserIcon from '@/assets/icons/profile.svg';
import TruckIcon from '@/assets/icons/truck.svg';
import MessagesIcon from '@/assets/icons/messages.svg';

export default {
  components: {
    UserIcon,
    TruckIcon,
    MessagesIcon,
  },
};
</script>
